module.exports = __webpack_public_path__ + "static/img/mode-group@2x.947fe158.png";